<template>
  <footer class="footer" id="app-footer">
    <div class="container footer-content">
      <div class="footer-brand">
        <router-link to="/" class="footer-logo" id="footer-logo-link">
          <img :src="siteConfig.logoUrl || require('@/assets/logo.jpg')" alt="Logo" class="logo-img">
          <span class="logo-text">{{ siteConfig.productName || 'AI一页纸报告' }}</span>
        </router-link>
        <p class="footer-tagline">
          {{ siteConfig.footerDescription  }}
        </p>
        <div class="footer-socials">
          <span class="social-icon" title="微信公众号">
            <svg class="icon-svg icon-svg-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
            </svg>
          </span>
          <span class="social-icon" title="电子邮箱">
            <svg class="icon-svg icon-svg-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </span>
          <span class="social-icon" title="商务电话">
            <svg class="icon-svg icon-svg-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
          </span>
        </div>
      </div>

      <div class="footer-links-grid">
        <div class="footer-links-col">
          <h4>核心产品</h4>

          <router-link v-if="user" to="/pricing" id="footer-link-pricing">价格套餐</router-link>
          <router-link to="/enterprise" id="footer-link-enterprise">企业服务</router-link>
        </div>

        <div class="footer-links-col">
          <h4>合规与条款</h4>
          <router-link to="/compliance?tab=privacy" id="footer-link-privacy">隐私政策</router-link>
          <router-link to="/compliance?tab=terms" id="footer-link-terms">服务条款</router-link>
          <router-link to="/compliance?tab=disclaimer" id="footer-link-disclaimer">免责声明</router-link>
        </div>

        <div class="footer-links-col">
          <h4>关于平台</h4>
          <router-link to="/about" id="footer-link-about">项目介绍</router-link>
          <router-link to="/about" id="footer-link-faq">常见问题</router-link>
          <a :href="`mailto:${siteConfig.businessEmail || 'contact@qingzhicheng.com'}`" id="footer-link-contact">联系我们</a>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container footer-bottom-container">
        <p>{{ siteConfig.copyrightText }}</p>
        <p class="icp-info">
          <a v-if="siteConfig.icpUrl" :href="siteConfig.icpUrl" target="_blank" rel="noopener">{{ siteConfig.icpNumber }}</a>
          <span v-else>{{ siteConfig.icpNumber  }}</span>
          <template v-if="siteConfig.publicSecurityNumber"> · <a :href="siteConfig.publicSecurityUrl || '#'" target="_blank" rel="noopener">{{ siteConfig.publicSecurityNumber }}</a></template>
          <span> | {{ siteConfig.riskNotice || '投资有风险，入市需谨慎' }}</span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'
import { getUser } from '@/utils/auth'

export default {
  name: 'AppFooter',
  computed: {
    ...mapState(['siteConfig']),
    user() {
      const route = this.$route.fullPath
      return route ? getUser() : null
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: var(--bg-tertiary);
  border-top: var(--border-subtle);
  padding: 5rem 0 2.5rem;
  margin-top: auto;
  position: relative;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4rem;
  margin-bottom: 4.5rem;
}

.footer-brand {
  flex: 1.5;
  max-width: 480px;
}

.footer-logo {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-display);
  font-size: 1.35rem;
  font-weight: 800;
  color: var(--text-primary);
  margin-bottom: 1.25rem;
  margin-top: -0.5rem;
}

.logo-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  color: var(--accent-primary);
  filter: drop-shadow(0 0 4px rgba(37, 99, 235, 0.25));
}

.logo-img {
  width: 2.8rem;
  height: 2.8rem;
  object-fit: contain;
  border-radius: 4px;
}

.footer-tagline {
  font-size: 0.85rem;
  line-height: 1.75;
  color: var(--text-secondary);
  margin-bottom: 1.75rem;
}

.footer-socials {
  display: flex;
  gap: 1rem;
}

.social-icon {
  font-size: 1.15rem;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: var(--bg-secondary);
  border: var(--border-subtle);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: var(--transition-fast);
}

.social-icon:hover {
  background: rgba(37, 99, 235, 0.08);
  border-color: rgba(37, 99, 235, 0.3);
  box-shadow: 0 0 10px rgba(37, 99, 235, 0.15);
  transform: translateY(-3px);
}

.footer-links-grid {
  flex: 2;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.footer-links-col h4 {
  font-size: 0.95rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 1.5rem;
  color: var(--text-primary);
  font-family: var(--font-display);
}

.footer-links-col a {
  display: block;
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin-bottom: 0.85rem;
  transition: var(--transition-fast);
}

.footer-links-col a:hover {
  color: var(--accent-primary);
  text-shadow: 0 0 8px rgba(37, 99, 235, 0.2);
  transform: translateX(4px);
}

.footer-bottom {
  border-top: var(--border-subtle);
  padding-top: 2rem;
  font-size: 0.75rem;
  color: var(--text-muted);
}

.footer-bottom-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.icp-info {
  text-align: right;
  letter-spacing: 0.5px;
}

@media (max-width: 992px) {
  .footer-content {
    flex-direction: column;
    gap: 3rem;
  }

  .footer-brand {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
  .footer-links-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-bottom-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .icp-info {
    text-align: left;
  }
}
</style>
